export default "__VITE_ASSET__66IO3Ubg__"